import { Core } from "@ancademy/vse-client";
import { css } from "@emotion/css";
import { Form, Slider } from "antd";
import React, { useEffect } from "react";
import { ICreateParams } from "../config";

export function Create({ params, setParams }: Core.ICreateProps<ICreateParams>) {
  useEffect(() => {
    if (params.behaviorScore) {
      return;
    }
    setParams({
      behaviorScore: 66,
      questionScore: 22,
    });
  }, []);
  return (
    <>
      <Form.Item label="赋分权重" wrapperCol={{ offset: 1 }}>
        <div
          className={css`
            max-width: 40rem;
          `}
        >
          <Slider
            className={css`
              .ant-slider-track {
                background: transparent !important;
              }
            `}
            tooltipVisible={false}
            range={{ draggableTrack: true }}
            value={[params.behaviorScore, params.behaviorScore + params.questionScore]}
            onChange={(val) =>
              setParams({
                behaviorScore: val[0],
                questionScore: val[1] - val[0],
              })
            }
          />
          <ul
            className={css`
              display: flex;
              justify-content: space-between;
              font-size: 1rem;
            `}
          >
            <li>实验决策：{params.behaviorScore}分</li>
            <li>问答题：{params.questionScore}分</li>
            <li>实验报告：{100 - params.behaviorScore - params.questionScore}分</li>
          </ul>
        </div>
      </Form.Item>
    </>
  );
}
